module.exports = __webpack_public_path__ + "ui-static/img/couldnt-find_light.74c33760.svg";